import React, { useState, useCallback } from 'react';

import { Link } from '@hpstellar/core/visId';

import GiftCardBalanceModal from '../../gift-card/gift-card-balance';

import './css/search-page-gift-card-link.less';

const toggleModal = (gcModalOpen, setGCModalOpen) => () => {
    setGCModalOpen(!gcModalOpen);
};

export default props => {
    const { searchKey, validGiftCardSearch, giftCardLabel } = props || {};
    const [gcModalOpen, setGCModalOpen] = useState(false);
    const enableGiftCardBalanceCheck = validGiftCardSearch || (typeof searchKey === 'string' && /^gift card/gi.test(searchKey))

    const giftCardTitle = typeof giftCardLabel === 'string' ? giftCardLabel : "Check Your Gift Card's Balance";
    const openGcModal = useCallback(() => {
        setGCModalOpen(true);
    }, [])
    return  enableGiftCardBalanceCheck && (
        <>
            <Link theme='light' className='srp-gc-modal-button' onClick={openGcModal}>{giftCardTitle}</Link>
            <GiftCardBalanceModal isOpen={gcModalOpen} onModalClose={toggleModal(gcModalOpen, setGCModalOpen)} />
        </>
    )
}